(() => {
  const OPEN_DURATION = 750;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const curtain = () => {
    let el = document.querySelector('.hall-curtain');
    if (!el) {
      el = document.createElement('div');
      el.className = 'hall-curtain';
      el.setAttribute('aria-hidden', 'true');
      document.body.appendChild(el);
    }
    return el;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-hall-door]');
    if (!link) return;
    // Let new-tab / new-window clicks behave normally.
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (reduceMotion.matches) return;

    event.preventDefault();
    if (document.body.classList.contains('hall-is-leaving')) return;

    // Force a style flush so a freshly created curtain starts at opacity 0 and fades in.
    curtain().getBoundingClientRect();
    link.closest('.hall-door')?.classList.add('is-opening');
    document.body.classList.add('hall-is-leaving');
    window.setTimeout(() => {
      window.location.href = link.href;
    }, OPEN_DURATION);
  });

  // Coming back via the browser's back button restores the page from cache with the doors still open.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.body.classList.remove('hall-is-leaving');
    document.querySelectorAll('.hall-door.is-opening').forEach((door) => door.classList.remove('is-opening'));
  });

  // Looping door animations (flames, fog, flicker, floating product) only run while the door is on screen.
  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(
    (entries) => entries.forEach((entry) => entry.target.classList.toggle('is-offscreen', !entry.isIntersecting)),
    { rootMargin: '120px 0px' }
  );
  const watch = (root) => root.querySelectorAll('.hall-door:not([data-hall-watched])').forEach((door) => {
    door.dataset.hallWatched = '';
    observer.observe(door);
  });
  const start = () => {
    watch(document);
    // Filtering and sorting re-render the product grid; pick up the new doors.
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        watch(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
